<template>
    <Table
        :cursorPointer="false"
        :isBorder="true"
        class="w-full mt-2.5"
    >
        <template #thead>
            <tr>
                <td class="px-4 py-2">
                    授權人/身份證字號
                </td>
                <td class="px-4 py-2">
                    授權扣款銀行
                </td>
                <td class="px-4 py-2  w-[15rem]">
                    授權銀行帳號
                </td>
                <td class="px-4 py-2  w-1/4">
                    授權人行動電話
                </td>
            </tr>
        </template>
        <template #tbody>
            <tr class="text-gray-900">
                <td class="px-4 pt-6 pb-3 break-all w-1/4 align-top">
                    <p>
                        {{ data?.name||'未指定' }}<br>
                        {{ data?.id }}
                    </p>
                </td>
                <td class="px-4 pt-6 pb-3 w-1/4 align-top">
                    <div class="mr-4">
                        {{ data?.shortBankCode }}
                    </div>
                    <div>
                        {{ data?.bankName }}
                    </div>
                </td>
                <td class=" px-4 pt-6 pb-3 align-top">
                    <slot name="input" />
                </td>
                <td class="px-4 pt-6 pb-3 break-all">
                    <p>
                        {{ data?.mobile }}
                    </p>
                    <ul class="text-tip text-sm">
                        <li>此電話僅供本授權之用，倘欲變更保單電話請從 首頁申請保單變更。</li>
                    </ul>
                </td>
            </tr>
        </template>
    </Table>
</template>

<script>
import Table from '@/components/table/TableBase.vue';

export default {
    components: {
        Table
    },
    props: {
        data: {
            type: Object,
            default: () => { }
        }
    },
};
</script>
